import React from "react";
import Grid from "@mui/material/Grid";
import Timeline from "@mui/lab/Timeline";
import TimelineItem from "@mui/lab/TimelineItem";
import TimelineSeparator from "@mui/lab/TimelineSeparator";
import TimelineConnector from "@mui/lab/TimelineConnector";
import TimelineContent from "@mui/lab/TimelineContent";
import TimelineDot from "@mui/lab/TimelineDot";
import { useTheme } from '@mui/material/styles';

const CustomerJourney = ({ name, profileDetailsExtended }) => {
    const journey = profileDetailsExtended?.customerJourney || [];
    const theme = useTheme();
    // Use same mobile check as in OurTechnology.js
    const isMobile = typeof window !== 'undefined' && window.innerWidth <= 600;
    return (
        <Grid container style={{ padding: isMobile ? '60px 30px' : '60px 60px', width: '100%' }}>
            <Grid size={12}>
                <h3 style={{ margin: 0, marginBottom: 20, fontSize: '26px' }}>Customer Journey</h3>
            </Grid>
            <Grid size={12} style={{ display: 'flex', justifyContent: 'center' }}>
                <div style={{ width: '100%', maxWidth: 700 }}>
                    <Timeline position="alternate">
                        {journey.map((step, index) => (
                            <TimelineItem key={index}>
                                <TimelineSeparator>
                                    <TimelineDot style={{ backgroundColor: theme.palette.primary.main }} />
                                    {index < journey.length - 1 && <TimelineConnector />}
                                </TimelineSeparator>
                                <TimelineContent>
                                    <div style={{ marginBottom: 4, fontWeight: 600, fontSize: '15px' }}>{`Step ${index + 1}`}</div>
                                    <span style={{ fontSize: '16px', lineHeight: 1.6 }}>{step}</span>
                                </TimelineContent>
                            </TimelineItem>
                        ))}
                    </Timeline>
                </div>
            </Grid>
        </Grid>
    );
};

export default CustomerJourney;
